/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import React, { Fragment } from 'react'
import { useNavigate } from 'react-router-dom'

import { EuiButton, EuiFlexGroup, EuiFlexItem, EuiLink, EuiSpacer, EuiText } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import { useBillingHistoryUrl } from '@modules/urls/billing'

import { supportPortalUrl } from '@/apps/userconsole/urls'

interface Props {
  organizationId: string
}

const InactiveDetails = ({ organizationId }: Props) => {
  const navigate = useNavigate()
  const billingHistoryUrl = useBillingHistoryUrl(organizationId)

  return (
    <Fragment>
      <EuiText size='s' data-test-id='payment-details'>
        <FormattedMessage
          id='plan-overview.payment-details.inactive-details'
          defaultMessage='Inactive account'
        />
      </EuiText>

      <EuiSpacer size='l' />

      <EuiFlexGroup alignItems='center'>
        <EuiFlexItem grow={false}>
          <EuiButton element='button' fill={true} href={supportPortalUrl} target='_blank'>
            <FormattedMessage
              id='plan-overview.payment-details.inactive.contact-button'
              defaultMessage='Contact support'
            />
          </EuiButton>
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiLink onClick={() => navigate(billingHistoryUrl)}>
            <FormattedMessage
              id='billing-overview.payment-details.view-billing-history'
              defaultMessage='View billing history'
            />
          </EuiLink>
        </EuiFlexItem>
      </EuiFlexGroup>
    </Fragment>
  )
}

export default InactiveDetails
